<template>
    <Form ref="distribute" :model="distribute" :rules="ruleValidate" label-position="right" :label-width="200" v-if="distribute">
        <FormItem label="公司名称" prop="company">
          <dropdown @item-click="dropDownClick" :isNeedSearch="true" :companies="companies" :checkObjName="checkObjName"></dropdown>
        </FormItem>
        <FormItem label="备注" prop="reason">
            <Input v-model="distribute.remark" placeholder="请输入备注"></Input>
        </FormItem>
        <FormItem label="添加代理商商品" prop="distribute_goods">
          <Button style="margin-left: 8px" @click="addGoods()">添加</Button>
          <List>
            <ListItem v-for="(good, ind) of goods" :key="ind" style="border: 1px solid red; margin-top: 6px; padding: 0 10px; border-radius: 10px;">
              <List>
                <ListItem>
                  <div style="display: flex;" v-if="goods.categories">
                    <label style="width: 100px; text-align:right; padding-right: 10px;">商品名称</label>
                    <Select v-model="good.category_id" style="width: 250px; margin-right: 10px; margin-left: 10px;">
                      <Option v-for="category in goods.categories" :value="category.category_id" :key="category.category_id">{{ category.alias }}</Option>
                    </Select>
                  </div>
                  <button type="button" style="float:right; padding: 0 10px; width: 150px; " @click="delBoxGoods(ind)">删除</button>
                </ListItem>
              </List>
            </ListItem>
          </List>
        </FormItem>
        <FormItem>
            <Button ref="but_submit" type="primary" @click="formHandleSubmit('distribute')" :disabled="butDisabled">提交</Button>
        </FormItem>
    </Form>
</template>
<script>
import Dropdown from '../member/components/dropdown.vue'
export default {
    props: {
        distribute: Object,
        user_types: Array,
        companies: Array,
        checkObjName: String,
    },
    data () {
        return {
            goods: [],
            categories: null,
            butDisabled: false,
            ruleValidate: {
            },
        };
    },
    components: {
      Dropdown,
    },
    watch:{
    },
    methods: {
        formHandleSubmit: function (name) {
            if (this.goods.length === 0){
              this.$Message.error("商品不能为空!");
              return;
            }
            let distribute_goods = [];
            try {
              this.goods.forEach((goods_) => {
                delete goods_.categories;
                if (!goods_.category_id){
                  throw 'error';
                }else{
                  distribute_goods.push(goods_);
                }
              });
            } catch (e) {
              console.log(e)
              this.$Message.error("请完整填写商品信息!");
              return;
            }
            this.distribute.agent_goods = distribute_goods;
            this.butDisabled = true;
            setTimeout(() => { this.butDisabled = false; }, 3000);
            this.$refs[name].validate((valid) => {
                if (valid) {
                    // 验证通过
                    console.log("验证通过");
                    this.loading = true;
                    this.error = null;
                    this.$emit("handleSubmit", this.distribute);
                } else {
                    this.$Message.error("请输入正确的数据!");
                }
            });
        },
        dropDownClick(e) {
          this.distribute.company_id = e.id;
          // this.goods[e.index].company_id = e.id;
          this.axios.get("agentGoods/totalList?company_id="+e.id).then((res) => {
            this.goods.categories = res.data.agent_goods;
            this.$forceUpdate();
          });
        },
        addGoods: function () {
          if(!this.goods.categories){
            this.$Message.error("请先选择公司名称")
            return
          }
          this.goods.push({});
          this.axios.get("couponCategories/totalList").then((res) => {
            this.goods.categories = res.data.coupon_categories;
            this.$forceUpdate();
          });
        },
        delBoxGoods (ind) {
          let delIndex = -1;
          for (let i = 0; i < this.goods.length; i++) {
            console.log(this.goods[i]);
            if (i === ind) {
              delIndex = i;
            }
          }
          if (delIndex > -1) {
            this.goods.splice(delIndex, 1);
          }
        },
    },
};
</script>
